import { Search, X } from "lucide-react";

interface SearchInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchInput({ value, onChange, placeholder = "Buscar…", className }: SearchInputProps) {
  return (
    <div className={`relative ${className || ""}`}>
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-9 pr-8 py-2 rounded-lg border border-slate-300 text-sm outline-none focus:border-blue-500"
      />
      {value && (
        <button
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 text-slate-400 hover:text-slate-600 rounded"
          title="Limpar"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}

/** Helper de filtragem por substring case-insensitive em vários campos. */
export function matchBusca<T>(items: T[], q: string, fields: ((it: T) => string | null | undefined)[]) {
  const term = q.trim().toLowerCase();
  if (!term) return items;
  const semAcento = (s: string) => s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
  const t = semAcento(term);
  return items.filter((it) => fields.some((f) => {
    const v = f(it);
    return v ? semAcento(String(v)).includes(t) : false;
  }));
}
